<template>
    <form dusk="registration-step-1"  data-vv-scope="form1" class="step" @submit.prevent="goToStep2">
      <div class="form-inner">
            <div class="headline" v-html="trans('reg.birthdate')"></div>
            <label>
                <input
                    v-if="isTouch() && isMobile"
                    id="dob"
                    name="dob"
                    v-model="dob"
                    type="date"
                    ref="dob_input"
                    v-validate="{required: true, date_format: 'yyyy-MM-dd',eighteen_yo:true}"
                    @change="onDatePickerChange"
                    v-bind:placeholder="trans('reg.birthdate')"
                    v-bind:data-vv-as="trans('reg.birthdate')"
                    :class="{ 'dark': true,'text-center':true, 'form-control': true, 'date-pristine':true, 'datepicker-input-reg': true, 'is-invalid-input': errors.has('form1.dob') }"
                    required
                />
                <DatePickerComponent
                    v-else
                    id="dob"
                    name="dob"
                    @change="onDatePickerChange"
                    v-model="dob"
                    v-bind:language="appLanguage"
                    v-bind:input-ref="'dob_input'"
                    v-bind:placeholder="trans('reg.birthdate')"
                    v-bind:data-vv-as="trans('reg.birthdate')"
                    v-bind:instant-show-calendar="true"
                    v-bind:input-class="{'dark': true, 'form-control': true, 'datepicker-input-reg': true, 'is-invalid-input': errors.has('form1.dob')}"
                    v-bind:centered="isMobile"
                    v-bind:v-validate="{required: true, eighteen_yo:true}"
                    required
                ></DatePickerComponent>

                <span class="form-error" :class="{'is-visible': errors.has('form1.dob')}">
                  {{ errors.first('form1.dob') }}
                </span>
            </label>
      </div>
      <div class="form-footer">
        <i18n path="reg.accept_terms_privacy_text" tag="div" class="input-title">
          <a class="color-green" @click="showPagePopup('privacy')">{{ trans('reg.privacy_policy') }}</a>
          <a class="color-green" @click="showPagePopup('terms')">{{ trans('reg.terms_of_use') }}</a>
        </i18n>
        <button @click="goToStep2" :disabled="errors.has('form1.dob') || firstopen" class="btn btn-long btn-registration-submit btn-rounded btn-primary" type="submit" id="button1">
          {{ trans('reg.next') }}
        </button>
      </div>
    </form>
</template>

<script>
    import DatePickerComponent from '@buddy/views/widgets/DatePickerComponent.vue';
    import {Validator} from "vee-validate";
    import moment from "moment/moment";
    Validator.extend('eighteen_yo', {
      validate: value => moment().diff(moment(value, 'YYYYMMDD'), 'years') >= 18
    });
    export default {
        mixins: [require('@general/lib/mixin').default],
        props: ['vars'],
        data() {
            return this.vars;
        },
        components: {
            DatePickerComponent,
        },
        methods: {
            showPagePopup(page) {
              app.showLightLoading(true);

              let title = page == 'terms' ? this.trans('reg.terms_of_use') : this.trans('reg.privacy_policy');

              axios.get('/api/getStaticPage/'+app.lang+'/'+page)
                  .then(({data}) => {
                    this.showErrorNotification(data.content);
                    app.showLightLoading(false);
                  })
                  .catch(e => {
                    app.showLightLoading(false);
                  })
            },
            onDatePickerChange($event) {
                this.firstopen = false;
                $($event.target).removeClass('date-pristine');
            },
            calculateAge(birthday) { // birthday is a date
              var ageDifMs = Date.now() - birthday;
              var ageDate = new Date(ageDifMs); // miliseconds from epoch
              return Math.abs(ageDate.getUTCFullYear() - 1970);
            },
            decodeLocation: async function(){
              try {
                let lat, lng, address;
                ({lat, lng, address} = await this.getCurrentPositionAndAddress(true))
                this.lat = lat
                this.lng = lng
                this.address = address.formattedAddress
                this.locality = address.locality
                this.location_type = 'automatic'
                this.state = address.state
                this.country = address.country
                this.country_code = address.country_code
                this.addressShow = address.formattedAddress;
                this.addressError = null
              } catch (e) {
                this.location_type = 'error';
              }
            },
            async goToStep2() {
                this.showLoadingButton('#button1')
                const dataVars = {email: this.email, password: this.password, dob: this.dob}

                let response = await axios.post('/api/register/validate-dob', dataVars)
                if (response.data.success) {

                    this.decodeLocation();
                    this.step = 2
                }else{
                  this.errors.add({
                    field: 'form1.dob',
                    msg: response.data.errors.dob[0]
                  })
                }
                this.restoreLoadingButton('#button1')
            },
        },
        activated(){
        },
        mounted() {
          if(this.isMobile){
            this.$nextTick(() => this.$refs.dob_input.focus())
          }
        },
    }
</script>
